import { env } from '../../env';
import { RequestOptions, ToastTypeEnum } from '../../models/Index';
import HttpService from '../httpService/HttpService';
import StateService from '../stateService/StateService';
const httpClient = HttpService.getAxiosClient();

const SGTA_BASE_URL = env.REACT_APP_SGTA_BASE_URL;

const getGuesttoken = async (dashboardUuid: string, tenantUuid: string, options?: RequestOptions) => {
    return (
        httpClient
            .get(`${SGTA_BASE_URL}/tenants/${tenantUuid}/dashboards/${dashboardUuid}/guest-token`, { ...options })
            .then((response) => {
                return response.data;
            })
            .catch((err) => {
                const defaultText = 'TOAST_MESSAGE.ERROR_REQUESTING_CUSTOMER_ID_AND_ROLE_TEXT';
                const msg = err.response?.data ? err.response.data : defaultText;
                StateService.toastMessage$.next({
                    source: 'CUSTOMER_SERVICE.GET_CUSTOMER_ID_AND_ROLE',
                    text: msg,
                    type: ToastTypeEnum.ERROR,
                });
            })
    );
};

const SgtaService = {
    getGuesttoken,
};

export default SgtaService;
